export default __webpack_public_path__ + "static/media/homeTileCasa.cd59ed98.jpeg";